import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discount-dialog',
  templateUrl: './discount-dialog.component.html',
  styleUrls: ['./discount-dialog.component.scss']
})
export class DiscountDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
